import styled from 'styled-components/macro';

export const Video = styled.video`
  height: 100%;
  width: 100%;
  object-fit: contain;
  border-radius: 8px;
  cursor: move;
`;
